export const remap_chargerCSV_items = (originalResults) => {
  for (const item of originalResults) {
    const keysToDelete = [];
    const keysToRename = {};

    // First pass: identify keys to rename
    Object.keys(item).forEach((key) => {
      // For Chargers database

      if (key === "Site") {
        keysToRename[key] = "site";
      }
      if (key === "Year") {
        keysToRename[key] = "year";
      }
      if (key === "Ports Range 1") {
        keysToRename[key] = "port_less_than_10_kw";
      }
      if (key === "Ports Range 2") {
        keysToRename[key] = "port_10_20_kw";
      }
      if (key === "Ports Range 3") {
        keysToRename[key] = "port_25_kw";
      }
      if (key === "Ports Range 4") {
        keysToRename[key] = "port_180_200_kw";
      }
      if (key === "Incentives/Rebates/Credits") {
        keysToRename[key] = "incentives";
      }
      if (key === "Master Incentives/Rebates/Credits") {
        keysToRename[key] = "master_access_incentives";
      }
      if (key === "Capital Planning Funding") {
        keysToRename[key] = "capital_planning_funding";
      }
      if (key === "Procurement Management Cost") {
        keysToRename[key] = "procurement_management_cost";
      }
      if (key === "Estimated Public Works Engineering Costs") {
        keysToRename[key] = "estimated_public_works_engineering_costs";
      }
      if (key === "Trenching Costs") {
        keysToRename[key] = "trenching_costs";
      }
      if (key === "Utility Upgrade Cost") {
        keysToRename[key] = "upgrade_cost_utility";
      }
      if (key === "Customer Upgrade Cost") {
        keysToRename[key] = "upgrade_cost_customer";
      }
      if (key === "Other Costs") {
        keysToRename[key] = "other_costs";
      }
      if (key === "Other Costs Description") {
        keysToRename[key] = "other_costs_description";
      }
      if (key === "Loan Amount") {
        keysToRename[key] = "loan_amount";
      }
    });

    // Second pass: rename keys
    Object.keys(keysToRename).forEach((oldKey) => {
      const newKey = keysToRename[oldKey];
      item[newKey] = item[oldKey];
      keysToDelete.push(oldKey);
    });

    // Third pass: delete old keys
    keysToDelete.forEach((key) => delete item[key]);
  }
  return originalResults;
};
export const remap_items = (originalResults) => {
  for (const item of originalResults) {
    const keysToDelete = [];
    const keysToRename = {};

    // First pass: identify keys to rename
    Object.keys(item).forEach((key) => {
      // For Fleet Data database
      if (key === "Vehicle Type") {
        keysToRename[key] = "vehicle_type";
      }
      if (key === "Description") {
        keysToRename[key] = "description";
      }
      if (key === "Existing Vehicle GHG Emissions") {
        keysToRename[key] = "ghg";
      }
      if (key === "State or Local Incentives Rebates or Credits") {
        keysToRename[key] = "state_incentives";
      }
      if (key === "Domicile") {
        keysToRename[key] = "Simplified Domicile";
      }
      if (key === "Site Address" || key === "Address") {
        keysToRename[key] = "address";
      }
      if (key === "EV Purchase Cost (Not Including Incentives)") {
        keysToRename[key] = "EV Purchase Cost pre-incentive";
      }
      if (key === "Federal Incentives Rebates or Credits") {
        keysToRename[key] = "IRA Incentives";
      }
      if (key === "Charger Assignment") {
        keysToRename[key] = "charger_assignment";
      }
      if (key === "Electrification Year") {
        keysToRename[key] = "Replacement Year";
      }
    });

    // Second pass: rename keys
    Object.keys(keysToRename).forEach((oldKey) => {
      const newKey = keysToRename[oldKey];
      item[newKey] = item[oldKey];
      keysToDelete.push(oldKey);
    });

    // Third pass: delete old keys
    keysToDelete.forEach((key) => delete item[key]);
  }
  return originalResults;
};
